<template>
	<div class="rightBlock" :class="{'disabled': !isDateFilter}">
		<field
				width="182px"
				margin="0"
				label-switch="Fleet approved"
				:switch-value="fleet_approved"
				@updateSwitch="onSwitch($event, 'fleet_approved')"
				color-switch="white"
				is-switch
		></field>
		<field
				width="230px"
				margin="0 10px 0 0"
				label-switch="Dispatch approved"
				:switch-value="dispatcher_approved"
				@updateSwitch="onSwitch($event, 'dispatcher_approved')"
				color-switch="orange"
				is-switch
		></field>
		<button :disabled="!isDateFilter" @click="onRefreshDate" class="mainBtn">
			<span class="btnText">refresh data</span>
		</button>
		<button @click="onUpdateTrucks" class="mainBtn updateTrucks">
			<span class="btnText">Update trucks</span>
		</button>
	</div>
</template>

<script>
import { mapActions } from "vuex";

export default {
	name: "RefreshDateBlock",
	props: {
		fleetApproved: Boolean,
		dispatcherApproved: Boolean,
		isDateFilter: Boolean,
		dateFilter: String,
		datesColor: Object
	},
	watch: {
		async dateFilter(date, oldDate) {
			if (date !== oldDate) {
				const { data } = await this.onTrucksRoadApproved({ date });
				const { dispatcher_approved, fleet_approved } = data || {};
				this.dispatcher_approved = Boolean(dispatcher_approved);
				this.fleet_approved = Boolean(fleet_approved);
			}
		},
		dispatcherApproved(val) {
			this.dispatcher_approved = val;
		}
	},
	data: () => ({
		fleet_approved: false,
		dispatcher_approved: false
	}),
	methods: {
		...mapActions([ 'onTrucksRoadRefresh', 'onTrucksRoadApproved', 'onFilterRefresh', 'onTrucksRoadUpdateTrucks', 'actionPreloader' ]),
		onSwitch({ value }, key) {
			this[key] = value;
		},
		async onRefreshDate() {
			const {
				dispatcher_approved,
				fleet_approved
			} = this.$data;

			const values = {
				date: this.dateFilter,
				dispatcher_approved,
				fleet_approved
			};

			await this.onTrucksRoadRefresh(values);
			this.onFilterRefresh();
		},
		async onUpdateTrucks() {
			this.actionPreloader(true);
			const { status } = await this.onTrucksRoadUpdateTrucks();
			if (status) {
				this.$emit('updateHardTrucks');
			}
			this.actionPreloader(false);
		},
		initData() {
			this.fleet_approved = this.fleetApproved;
			this.dispatcher_approved = this.dispatcherApproved;
		}
	},
	mounted() {
		this.initData();
	}
};
</script>

<style lang="scss">
.updateTrucks {
	margin-left: 15px;
}

.rightBlock.disabled {
	pointer-events: none;
	opacity: .6;
}
</style>
